import * as React from 'react';

const Offbike = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.2334 21V13.2969L0.819734 17.2344L0 15.7656L6.55787 12L0 8.23438L0.819734 6.76562L7.2334 10.7031V3H8.7666V10.7031L15.1803 6.76562L16 8.23438L9.44213 12L16 15.7656L15.1803 17.2344L8.7666 13.2969V21H7.2334Z"
            fill="currentColor"
        />
    </svg>
);

export default Offbike;
